import type { FC } from "react";
import { Form } from "react-bootstrap";
import { useForm } from "../../common/form/useForm";
import { ExtraForm } from "../../common/pure/ExtraFormGroup";
import { Button } from "../../components/Button";
import { useOnboarding } from "./useOnboarding";
import "./FormGenerateOverview.css";

type Props = {
	onSuccess?: () => void;
};

export const FormGenerateOverview: FC<Readonly<Props>> = ({ onSuccess }) => {
	const {
		websiteOverview: { isPending, mutateAsync },
	} = useOnboarding();
	const form = useForm({
		initialValues: {
			url: "",
		},
		onSubmit: async (values) => {
			const data = await mutateAsync(values);

			onSuccess?.();
			return data;
		},
	});

	return (
		<Form className="form-generate-overview" onSubmit={form.handleSubmit}>
			<p>Give us your website address.</p>

			<p>
				We will go take a look at your site, social media accounts and any
				marketing that we can find and make an attempt to describe your business
				and marketing tone. This is your first step to creating a highly
				personalized marketing plan for your business.
			</p>

			<div className="wrapper">
				<ExtraForm.Group label="">
					<ExtraForm.Control
						type="text"
						placeholder="Write the address of your website"
						{...form.getFieldProps("url")}
						{...form.getFieldState("url")}
					/>
				</ExtraForm.Group>

				<Button loading={isPending} type="submit">
					Evaluate my business
				</Button>
			</div>
		</Form>
	);
};
